import { Stack, StackProps, Typography } from "@mui/material";
import { ReactNode } from "react";

interface PrintComponentDataProps extends StackProps {
    label?: ReactNode,
    value?: ReactNode
}

export default function PrintComponentData({
    label,
    value,
    ...props
}: PrintComponentDataProps) {
    return <Stack direction={"row"} gap={3} {...props}>
        <Typography variant="subtitle1" fontWeight={"bold"}>{label}{value ? ": " : ""}</Typography>
        {value && <Typography variant="body1">{value}</Typography>}
    </Stack>
}